import type { LoadingSpinnerColor, LoadingSpinnerSize } from '@components/atoms';
import { cva } from 'class-variance-authority';
import { cn } from '../../../utils';

const spinnerVariants = cva('animate-spin rounded-full border-dashed border-t-transparent', {
	variants: {
		color: {
			primary: 'border-primary',
			secondary: 'border-secondary',
			accent: 'border-accent',
			white: 'border-white',
		},
		size: {
			xs: 'h-1 w-1 border',
			sm: 'h-4 w-4 border-2',
			md: 'h-5 w-5 border-3',
			lg: 'h-7 w-7 border-4',
		},
	},
	defaultVariants: {
		color: 'primary',
		size: 'md',
	},
});

interface LoadingSpinnerProps {
	color?: LoadingSpinnerColor;
	size?: LoadingSpinnerSize;
	className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
	color = 'primary' as LoadingSpinnerColor,
	size = 'md' as LoadingSpinnerSize,
	className,
}) => {
	return (
		<div
			className={cn(spinnerVariants({ color, size }), className)}
			data-testid="loading-spinner"
			data-aid="loading-spinner"
		/>
	);
};
